<template>
  <div class="m-5">
    <d-tabs v-model="activeTab">
      <d-tab-item label="Mentees">
        <mentees-table :mentor="user" />
      </d-tab-item>
      <d-tab-item label="Mentors">
        <mentors-table :mentee="user" />
      </d-tab-item>
    </d-tabs>
  </div>
</template>

<script>
  export default {
    name: 'MentorTabbedPage',
  };
</script>

<script>
  import axios from 'axios';

  export default {
    parent: true,
    props: {
        user: {
            type: Object,
            default: () => {}
        }
    },

    data: () => ({
      activeTab: 0,
    }),

    mounted() {
    },

    methods: {

    },
  };
</script>